/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FilterEditIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Filter Edit',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m35.785 21.721-3.505-3.506a.739.739 0 0 0-.527-.215h-.023a.833.833 0 0 0-.564.247L20.344 29.069a.608.608 0 0 0-.153.256l-2.027 6c-.069.229.279.517.476.517a.313.313 0 0 0 .037 0c.168-.039 5.123-1.764 6-2.028a.6.6 0 0 0 .252-.151l10.824-10.829A.835.835 0 0 0 36 22.3a.743.743 0 0 0-.215-.579Zm-11.6 10.963c-1.314.395-3.3 1.229-4.43 1.568l1.56-4.431ZM30.946 2H3.054a1 1 0 0 0-.787 1.617L14 18.589V30a.992.992 0 0 0 1.68.825l3.98-4.153a1.22 1.22 0 0 0 .34-.845v-7.238L31.733 3.617A1 1 0 0 0 30.946 2Z"
    />
  </svg>`;
};
